import { OptionsObject, SnackbarKey, SnackbarMessage } from "notistack";
import { Map } from "ol";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";
import { AtonUnit } from "~/api/GeneratedApi";
import { getAtonLocation } from "~/utils/getAtonLocation";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { atonToMapItem } from "./dataConverters";
import { findSourceByTitle } from "./findSourceByTitle";
import { readMapSettings } from "./localMapSettings";

export function addAtoNsToMap(
  map: Map,
  atons: AtonUnit[],
  fitToExtend = false,
  enqueueSnackbar?: (
    message: SnackbarMessage,
    options?: OptionsObject | undefined,
  ) => SnackbarKey,
  errorText?: string,
): void {
  const source = findSourceByTitle(map, LayerTitle.AtoNs);
  // Clear the source before adding
  source.clear();
  const features: Feature<Geometry>[] = [];

  // Filter out some atons based on layer settings
  const faultFiltered = readMapSettings("atonOnlyFaulted")
    ? atons.filter((a) => a.activeFaultCount > 0)
    : atons;
  const filtered = readMapSettings("atonOnlyRemote")
    ? faultFiltered.filter((a) => a.seaDaticsRemoteMonitoring)
    : faultFiltered;

  filtered.forEach((e) => {
    // Convert to internal type
    const convertedAtoN = atonToMapItem(e);
    const location = getAtonLocation(e);
    if (!location) return;
    const transformed = [location.x, location.y];
    const point = new Point(transformed);
    const feat = new Feature({
      geometry: point,
    });
    feat.setProperties({ ...convertedAtoN });
    feat.set("overlayOffsetY", -20);
    feat.setId(convertedAtoN.mapId);
    features.push(feat);
  });
  source.addFeatures(features);
  source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
  if (fitToExtend) {
    const extend = source.getExtent();
    if (!extend.includes(Infinity)) map.getView().fit(extend);
    else {
      enqueueSnackbar?.(errorText, { variant: "warning" });
    }
  }
  map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
}
